import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useSWR from 'swr';

import axios from '../../admin-axios';
import { detectError } from '../../utils';
import classes from '../CustomersTable/index.module.scss';
import LongPaginationHandler from '../LongPaginationHandler';

const fetcher = (url) => axios.get(url).then((res) => res.data.data);
const AllPumps = ({ match }) => {
  const [view, setView] = useState('normal');
  const [searchResult, setSearchResult] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [searchError, setSearchError] = useState('');
  const searchRef = useRef();

  const [page, setPage] = useState(1);
  const {
    user: { stationId }
  } = useSelector((state) => state.auth);
  const {
    data,
    error,
    isLoading: loading,
    mutate
  } = useSWR(`/pump/show/all/${stationId}?page=${page}`, fetcher);

  if (error) {
    toast.error(detectError(error));
  }

  const paginate = (pageNumber) => {
    setPage(pageNumber);
    mutate();
  };

  const searchHandler = async (event) => {
    if (event.code === 'Enter') {
      setView('searching');
      // searchCustomers(stationId, searchRef.current.value);
      try {
        setLoadingSearch(true);
        const res = await axios.get(`/pump/search/${searchRef.current.value}/${stationId}`);
        setSearchResult(res.data.data.data);
        setView('searching');
        setLoadingSearch(false);
      } catch (e) {
        setSearchError(detectError(e));
      }
      searchRef.current.value = '';
    }
  };

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="w-100 h-100">
      <div className={`${classes.customers_search} mb-3`}>
        <input
          type="text"
          ref={searchRef}
          onKeyDown={searchHandler}
          className={`form-control p-3 ${classes.customers_search_input}`}
          placeholder="Search by pump ID"
          aria-label="search"
        />
      </div>
      {view === 'searching' && (
        <div className="">
          <button
            onClick={() => setView('normal')}
            type="button"
            className="mb-3 btn approved_transactions_general_button">
            Back to All Pumps
          </button>
        </div>
      )}
      <div className={classes.customers_table_wrapper}>
        <table className={`table table-striped ${classes.customers_table}`}>
          <thead>
            <tr>
              <th scope="col">Pump ID</th>
              <th scope="col">Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          {view === 'normal' && (
            <tbody>
              {loading && (
                <tr className="py-3">
                  <td colSpan={3}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {error && (
                <tr>
                  <td colSpan={3} className="w-100 text-center">
                    {error}
                  </td>
                </tr>
              )}
              {data &&
                data.data.length > 0 &&
                data.data.map((pump) => (
                  <tr key={pump.pump_id}>
                    <td>{pump.pump_id}</td>
                    <td style={{ color: pump.status === 'Active' ? 'green' : 'red' }}>
                      {pump.status}
                    </td>
                    <td>
                      <Link
                        to={`${match.url}/${pump.pump_id}`}
                        className={`w-100 btn btn-primary ${classes.customers_table_button}`}>
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              {data && data.data.length === 0 && (
                <tr>
                  <td colSpan={3} className="w-100 text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          )}
          {view === 'searching' && (
            <tbody>
              {loadingSearch && (
                <tr className="py-3">
                  <td colSpan={3}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {searchResult &&
                searchResult.length > 0 &&
                searchResult.map((pump) => (
                  <tr key={pump.pump_id}>
                    <td>{pump.pump_id}</td>
                    <td style={{ color: pump.status === 'Active' ? 'green' : 'red' }}>
                      {pump.status}
                    </td>
                    <td>
                      <Link
                        to={`${match.url}/${pump.pump_id}`}
                        className={`w-100 btn btn-primary ${classes.customers_table_button}`}>
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              {searchResult && searchResult.length === 0 && (
                <tr>
                  <td colSpan={3} className="w-100 text-center">
                    No Data Found
                  </td>
                </tr>
              )}
              {searchError && (
                <tr>
                  <td colSpan={3} className="w-100 text-center">
                    {detectError(searchError)}
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>
      {view === 'normal' && (
        <LongPaginationHandler
          elementsPerPage={data && data.per_page}
          totalElements={data && data.total}
          activePage={page}
          paginate={paginate}
        />
      )}
    </div>
  );
};

export default AllPumps;
